import React from "react";
import axios from 'axios';
import GoogleChart from '../../GoogleChart/GoogleChart';
import GoogleChartDemographic from '../../GoogleChart/GoogleChartDemographic';
import ParticipantsList from "./ParticipantsList";
import { MYPROFILE_SETTINGS_CONSTANT, SURVEY_ANALYSIS, BUBBLE_LOADING, SURVEY_PARTICIPATION, TABLE_LOADING } from '../../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, IMAGE_BASEURL } from '../../../constants/DotEnv';
import { Redirect,Link } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import CountUp from 'react-countup';
import download from 'downloadjs';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import createChartDownloadLink,{getActualImageString} from "../../GoogleChart/createChartDownloadLink";
import * as htmlToImage from 'html-to-image';

class Analyze extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            smallScreenDemographicList:'',
            smallScreenQuestionList:'',
            questionList: '',
            participated_user_list: '',
            surveyData: '',
            chart_loaded_once: false,
            send_chart_data: true,
            disablePDFButton: false,
            isExcelBtnDisabled: true,
            isCSVBtnDisabled: true,
            isPremiumExportBtnDisabled: true,
            showImageZipLoader: false,
            showNormalQuestionLoader: false,
            showDemoGraphQuestionLoader: false,
            redirectTo404:false,
            isImageDeleted: false,
            count : 0,
            isZeroParticipants:false,
            analysisDataViewType:false,
            crossTabulationData: [],
            questionArray: [],
            questionId1: '',
            questionId2: '',
            questionId1SelectedIndex: 0,
            questionId2SelectedIndex: 0,
            tableLoading: false,
            chartImagesZipDisabled: true
        }
        this.userData = JSON.parse(localStorage.getItem("userdata"));
        this.totalGraphLength = 0;
        this.questionCount = 0;
        this.mobileDevice = 0;
        this.ImagetoSendQuestion = []
        this.isGeneratingZip = false;
        this.allImageGroups = [];
    }
    // Attach click handlers to download buttons without pre-generating images
    wireDownloadButtons = () => {
        const qs = this.state.smallScreenQuestionList || [];
        const ds = this.state.smallScreenDemographicList || [];
        const userData = (() => { try { return JSON.parse(localStorage.getItem('userdata')); } catch(_) { return null; } })();
        try {
            // For normal questions
            qs.forEach((chart, index) => {
                const id = `download_chart_div_${index}`;
                const el = document.getElementById(id);
                if (el && !el.__wireWired) {
                    el.__wireWired = true;
                    
                    const newEl = el.cloneNode(true);
                    el.parentNode.replaceChild(newEl, el);
                    const cleanEl = document.getElementById(id);
                    cleanEl.__wireWired = true;
                    
                    // Enable button and set icon based on subscription
                    if (!userData?.plan_type) {
                        const iconEl = cleanEl.querySelector('i');
                        if (iconEl) { iconEl.className = 'ti-lock font-weight-bold pr-2'; iconEl.style.color = '#4a4a4a'; }
                        cleanEl.disabled = false;
                        cleanEl.addEventListener('click', () => {
                            const checkoutURL = userData?.account_type_category_id == 4 ? '/business-checkout' : userData?.account_type_category_id == 2 ? '/university-checkout' : '/checkout';
                            localStorage.setItem('redirectURL', window.location.href);
                            window.location = checkoutURL;
                        });
                    } else {
                        cleanEl.disabled = false;
                        cleanEl.__inFlight = false;
                        cleanEl.addEventListener('click', async () => {
                            if (cleanEl.__inFlight) return;
                            cleanEl.__inFlight = true;
                            const icon2 = cleanEl.querySelector('i');
                            if (icon2) { icon2.className = 'fa fa-spinner fa-spin mr-2'; icon2.style.fontSize='20px'; icon2.style.color='#128df5'; }
                            cleanEl.disabled = true;
                            try {
                                const img = await getActualImageString(this.state.smallScreenQuestionList[index], '');
                                if (img) {
                                    const date = new Date();
                                    const anchor = document.createElement('a');
                                    anchor.setAttribute('href', img);
                                    anchor.setAttribute('download', 'empirio_' + date.getTime() + '.png');
                                    anchor.style.display = 'none';
                                    document.body.append(anchor);
                                    anchor.click();
                                    anchor.remove();
                                }
                            } finally {
                                if (icon2) { icon2.className = 'ti-download text-dark pr-2'; }
                                cleanEl.disabled = false;
                                cleanEl.__inFlight = false;
                            }
                        });
                    }
                }
            });
            // For demographic
            ds.forEach((chart, index) => {
                const id = `download_chart_div_demographic_${index}`;
                const el = document.getElementById(id);
                if (el && !el.__wired) {
                    el.__wired = true;                    

                    const newEl = el.cloneNode(true);
                    el.parentNode.replaceChild(newEl, el);
                    const cleanEl = document.getElementById(id);
                    cleanEl.__wired = true;
                    
                    if (!userData?.plan_type) {
                        const iconEl = cleanEl.querySelector('i');
                        if (iconEl) { iconEl.className = 'ti-lock font-weight-bold pr-2'; iconEl.style.color = '#4a4a4a'; }
                        cleanEl.disabled = false;
                        cleanEl.addEventListener('click', () => {
                            const checkoutURL = userData?.account_type_category_id == 4 ? '/business-checkout' : userData?.account_type_category_id == 2 ? '/university-checkout' : '/checkout';
                            localStorage.setItem('redirectURL', window.location.href);
                            window.location = checkoutURL;
                        });
                    } else {
                        cleanEl.disabled = false;
                        cleanEl.__inFlight = false;
                        cleanEl.addEventListener('click', async () => {
                            if (cleanEl.__inFlight) return;
                            cleanEl.__inFlight = true;
                            const icon2 = cleanEl.querySelector('i');
                            if (icon2) { icon2.className = 'fa fa-spinner fa-spin mr-2'; icon2.style.fontSize='20px'; icon2.style.color='#128df5'; }
                            cleanEl.disabled = true;
                            try {
                                const img = await getActualImageString(this.state.smallScreenDemographicList[index], '');
                                if (img) {
                                    const date = new Date();
                                    const anchor = document.createElement('a');
                                    anchor.setAttribute('href', img);
                                    anchor.setAttribute('download', 'empirio_' + date.getTime() + '.png');
                                    anchor.style.display = 'none';
                                    document.body.append(anchor);
                                    anchor.click();
                                    anchor.remove();
                                }
                            } finally {
                                if (icon2) { icon2.className = 'ti-download text-dark pr-2'; }
                                cleanEl.disabled = false;
                                cleanEl.__inFlight = false;
                            }
                        });
                    }
                }
            });
            // For option-level buttons within multiple/scale questions
            qs.forEach((chart, index) => {
                if (chart && (chart.question_type_id === 5 || chart.question_type_id === 7)) {
                    const keyArray = Object.keys(chart);
                    keyArray.forEach((key) => {
                        if (key.substring(0,4) === 'data') {
                            const id = `download_chart_div_opt_${key}_${index}`;
                            const el = document.getElementById(id);
                            if (el && !el.__wired) {
                                el.__wired = true;
                                const icon = el.querySelector('i');
                                if (!userData?.plan_type) {
                                    if (icon) { icon.className = 'ti-lock font-weight-bold pr-2'; icon.style.color = '#4a4a4a'; }
                                    el.disabled = false;
                                    el.addEventListener('click', () => {
                                        const checkoutURL = userData?.account_type_category_id == 4 ? '/business-checkout' : userData?.account_type_category_id == 2 ? '/university-checkout' : '/checkout';
                                        localStorage.setItem('redirectURL', window.location.href);
                                        window.location = checkoutURL;
                                    });
                                } else {
                                    el.disabled = false;
                                    el.__inFlight = false;
                                    el.addEventListener('click', async () => {
                                        if (el.__inFlight) return;
                                        el.__inFlight = true;
                                        const icon2 = el.querySelector('i');
                                        if (icon2) { icon2.className = 'fa fa-spinner fa-spin mr-2'; icon2.style.fontSize='20px'; icon2.style.color='#128df5'; }
                                        el.disabled = true;
                                        try {
                                            const img = await getActualImageString(this.state.smallScreenQuestionList[index], key.substring(4));
                                            if (img) {
                                                const date = new Date();
                                                const anchor = document.createElement('a');
                                                anchor.setAttribute('href', img);
                                                anchor.setAttribute('download', 'empirio_' + date.getTime() + '.png');
                                                anchor.style.display = 'none';
                                                document.body.append(anchor);
                                                anchor.click();
                                                anchor.remove();
                                            }
                                        } finally {
                                            if (icon2) { icon2.className = 'ti-download text-dark pr-2'; }
                                            el.disabled = false;
                                            el.__inFlight = false;
                                        }
                                    });
                                }
                            }
                        }
                    })
                }
            })
        } catch(_) {}
    }
    // Build a safe filename fragment
    getSafeName = (str, fallback = 'Kreuztabelle') => {
        try {
            if (!str || typeof str !== 'string') return fallback;
            return str
                .replaceAll('ä','ae').replaceAll('Ä','Ae')
                .replaceAll('ö','oe').replaceAll('Ö','Oe')
                .replaceAll('ü','ue').replaceAll('Ü','Ue')
                .replaceAll('ß','ss')
                .replace(/[\s\t\n]+/g,'_')
                .replace(/[\\/:*?"<>|#%&{}$!'@+=`^~[\],.;]/g,'_')
                .substring(0,80);
        } catch(e){
            return fallback;
        }
    }
    // Export current crosstab table to CSV (semicolon separated)
    exportCrossTabToCSV = () => {
        const rows = this.state.crossTabulationData || [];
        if (!rows.length) return;
        const esc = (v) => {
            let s = (v === null || v === undefined) ? '' : String(v);
            // Normalize newlines and escape quotes
            s = s.replace(/\r?\n|\r/g, ' ');
            if (s.includes(';') || s.includes('"') || s.includes(' ')) {
                s = '"' + s.replace(/"/g, '""') + '"';
            }
            return s;
        };
        const csv = rows.map(r => r.map(esc).join(';')).join('\r\n');
        const q1 = this.state.questionArray[this.state.questionId1SelectedIndex]?.text || '';
        const q2 = this.state.questionArray[this.state.questionId2SelectedIndex]?.text || '';
        const name = `crosstab_${this.getSafeName(q1)}_vs_${this.getSafeName(q2)}.csv`;
        const base64 = btoa(unescape(encodeURIComponent(csv)));
        this.createAnchorforDownload(`data:text/csv;base64,${base64}`, name);
    }
    // Export current crosstab table to a real Excel .xlsx using SheetJS
    exportCrossTabToExcel = () => {
        const rows = this.state.crossTabulationData || [];
        if (!rows.length) return;
        const ws = XLSX.utils.aoa_to_sheet(rows);
        // Style header row (optional basic width)
        const colCount = rows[0]?.length || 0;
        const wscols = Array.from({ length: colCount }, () => ({ wch: 20 }));
        ws['!cols'] = wscols;
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Kreuztabelle');
        const q1 = this.state.questionArray[this.state.questionId1SelectedIndex]?.text || '';
        const q2 = this.state.questionArray[this.state.questionId2SelectedIndex]?.text || '';
        const name = `crosstab_${this.getSafeName(q1)}_vs_${this.getSafeName(q2)}.xlsx`;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(blob, name);
    }
    async componentDidMount() {
        let self = this;
        let usercheck = true;
        let redirectTo404 = false
        this.userId = '';
        if (this.userData) {
            this.surveyEditDataId = (this.props.match.params.surveyid) ? window.atob(this.props.match.params.surveyid) : '';
            this.userId = this.userData.id;
            this.Api_request_header = {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.userData.token
            }
            let dataObject = {
                "survey_id": this.surveyEditDataId
            }
                if (this.surveyEditDataId) {
                    if (this.surveyEditDataId && this.userData.token) {
                        /* --- Get Survey Details --- */
                        await axios.get(API_URL + '/surveyresult/getSurveyBriefData/' + LANGUAGE_CODE + "/" + this.surveyEditDataId + "/" + this.userData.id + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                            if(res.data.success.userfound === 0){
                                usercheck = false;
                                redirectTo404 = true
                                // self.setState({
                                //     redirectTo404:true
                                // })
                            }
                            self.setState({
                                surveyData: res.data.success.surveybriefdata
                            })
                            let survey_color = res.data.success.surveybriefdata.survey_color
                            let color = survey_color? survey_color: '#1992E7'
                            if(res.data.success.surveybriefdata) localStorage.setItem('survey_color', color)
                        }).catch((error) => {
                            console.log(error)
                            if (error && error.response && error.response.data) {
                                let msg = error.response.data['error']
                                if (msg === 'Invalid User') {
                                    redirectTo404 = true
                                    // self.setState({ redirectTo404: true })
                                }
                            }
                        })
                        // eslint-disable-next-line
                        await axios.post(API_URL + "/surveyresult/deleteImagefiles" + '?uId=' + this.userId, dataObject, { headers: this.Api_request_header })
                        .then(()=>{
                            self.setState({
                                isImageDeleted: true
                            })
                        })
                        .catch(err => console.log(err))
                }
            }
            if(usercheck){
                // default mobile Device value is 0, if width is less than 575px value is 1.
                if (window.innerWidth >= 320 && window.innerWidth <= 575) {
                    this.mobileDevice = 1;
                }
                /* --- Get Question List for Chart Rendering --- */
                await axios.get(API_URL + "/surveyresult/getQuestiongraphdata/" + LANGUAGE_CODE + "/" + this.surveyEditDataId + '?uId=' + this.userId + '&mobileDevice=' + this.mobileDevice, { headers: this.Api_request_header }).then((res) => {
                    let qList = res.data.success.questiondata;
                    let IsSurveyHaveOnlyFreetextQuestion = res.data.success.IsSurveyHaveOnlyFreetextQuestion
                    if(IsSurveyHaveOnlyFreetextQuestion === 1){
                        self.setState({
                            showImageZipLoader : false,
                            disablePDFButton : true
                        })
                    }
                    // eslint-disable-next-line
                    qList.map((data, index)=>{
                        if(data.question_type_id === 1) {
                            if(!data.tagcloud.length) {
                                res.data.success.questiondata.splice(index,1);
                            }
                        }
                    })
                    self.setState({
                        questionList: res.data.success.questiondata,
                        demographicList: res.data.success.demographic,
                    })
                }).catch((error) => {
                    console.log(error)
                    if (error && error.response && error.response.data) {
                        let msg = error.response.data['error']
                        if (msg === 'Invalid User') {
                            // self.setState({ redirectTo404: true })
                            redirectTo404 = true
                        }
                    }
                })
                 /*--Get normal question data---*/
                 await axios.get(API_URL + "/surveyresult/getQuestiongraphdata/" + LANGUAGE_CODE + "/" + this.surveyEditDataId + '?uId=' + this.userId + '&mobileDevice=0', { headers: this.Api_request_header }).then((res) => {
                    let qList = res.data.success.questiondata;
                    let IsSurveyHaveOnlyFreetextQuestion = res.data.success.IsSurveyHaveOnlyFreetextQuestion
                    if(IsSurveyHaveOnlyFreetextQuestion === 1){
                      self.setState({
                          disablePDFButton : true,
                          showImageZipLoader : false
                      })
                  }
                    // eslint-disable-next-line
                    qList.map((data, index)=>{
                        if(data.question_type_id === 1) {
                            if(!data.tagcloud.length) {
                                res.data.success.questiondata.splice(index,1);
                            }
                        }
                    })
                                        self.setState({
                                            smallScreenQuestionList: res.data.success.questiondata,
                                            smallScreenDemographicList: res.data.success.demographic
                                        }, () => {
                                                // After both question lists are present in state and DOM has rendered, wire buttons and update chart images ZIP readiness
                                                setTimeout(() => {
                                                        this.wireDownloadButtons();
                                                    this.updateChartImagesZipReadyIfDataLoaded();
                                                }, 500);
                                        })
                }).catch((error) => {
                    console.log(error)
                })
                /* --- Get User Request Data for All Participants --- */
                await axios.get(API_URL + '/surveyresult/getParticipantuserBySurveyId/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    // Ensure deterministic ascending order by end time on the client
                    const data = res.data.success;
                    if (data && Array.isArray(data.userparticipated)) {
                        const parseFallback = (u) => {
                            // Fallback: parse dd.mm.yyyy and "HH:MM Uhr" strings
                            try {
                                if (!u.user_survey_date || !u.user_survey_time) return Number.MAX_SAFE_INTEGER;
                                const [d,m,y] = u.user_survey_date.split('.') || [];
                                const hm = (u.user_survey_time || '').replace(' Uhr','');
                                const [H,Mi] = hm.split(':') || [];
                                const dt = new Date(parseInt(y,10), parseInt(m,10)-1, parseInt(d,10), parseInt(H,10), parseInt(Mi,10), 0);
                                return dt.getTime() / 1000;
                            } catch(_e){ return Number.MAX_SAFE_INTEGER; }
                        };
                        data.userparticipated.sort((a,b) => {
                            const au = (typeof a.completed_at_unix === 'number') ? a.completed_at_unix : parseFallback(a);
                            const bu = (typeof b.completed_at_unix === 'number') ? b.completed_at_unix : parseFallback(b);
                            return au - bu;
                        });
                    }
                    self.setState({
                        participated_user_list: data,
                        loading: 'false',
                    })
                    if (res.data.success.userparticipated.length) {
                        this.setState({
                            isExcelBtnDisabled: false,
                            isCSVBtnDisabled: false,
                            isPremiumExportBtnDisabled:false,
                            disablePDFButton: false,
                            showImageZipLoader: false
                        })
                    } else {
                        self.setState({ showImageZipLoader: false, disablePDFButton: false })
                        self.setState({ isZeroParticipants: true })
                    }
                }).catch((error) => {
                    console.log(error)
                    if (error && error.response && error.response.data) {
                        let msg = error.response.data['error']
                        if (msg === 'Invalid User') {
                            // self.setState({ redirectTo404: true })
                            redirectTo404 = true
                        }
                    }
                    self.setState({
                        loading: 'false'
                    })
                })
               
                if(this.state.demographicList && this.state.demographicList.length) {
                    this.totalGraphLength = this.state.demographicList.length;
                    this.questionCount = this.totalGraphLength;
                }
                if(this.state.questionList && this.state.questionList.length) {
                    // Only generate downloadable images for plus-plan users
                    if (this.userData && this.userData.plan_type) {
                        // Pre-check: ensure there's at least one renderable chart
                        const hasRenderable = this.state.questionList.some((data) => (
                            data.question_type_id !== 1 || (data.tagcloud && data.tagcloud.length)
                        ));
                        if (hasRenderable) {
                            // Defer image generation to explicit user actions (ZIP or per-chart download)
                            // eslint-disable-next-line
                            this.state.questionList.map((data,index)=>{
                                if(data.question_type_id === 1 && !data.tagcloud.length) {
                                    // eslint-disable-next-line
                                    return;
                                }
                                if (data.question_type_id !== 1) {
                                    this.questionCount = this.questionCount + 1;
                                }
                                this.totalGraphLength = this.totalGraphLength + 1;
                            });
                        }
                    }
                }
            }
        }
        self.setState({redirectTo404 : redirectTo404})
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isDrawChart !== this.props.isDrawChart) {
            this.setState({
                chart_loaded_once: true
            })
        }
        // Enable chart images ZIP button once chart data is present
        if (this.state.chartImagesZipDisabled) {
            this.updateChartImagesZipReadyIfDataLoaded();
        }
        
        if ((prevState.smallScreenQuestionList !== this.state.smallScreenQuestionList || 
             prevState.smallScreenDemographicList !== this.state.smallScreenDemographicList) &&
            this.state.smallScreenQuestionList && this.state.smallScreenDemographicList) {
            setTimeout(() => {
                this.wireDownloadButtons();
            }, 500);
        }
    }
    loadGoogleChart = () => {
        if (this.state.questionList) {
            let questions = this.state.questionList;
            return questions.questiondata.map((question, index) => (
                <GoogleChart chartData={question} key={index} elementNo={index} chart_loaded_once={this.state.chart_loaded_once} smallScreenQuestionList={this.state.smallScreenQuestionList['questiondata'][index]} chartColor={this.state.surveyData.survey_color}/>
            ))
        }
        else {
            return null;
        }
    }
    /* --- Create Anchor Tag with Link remove it once File is downloaded --- */
    createAnchorforDownload(file_path,file_name='') {
        var ua = window.navigator.userAgent;
        if (navigator.msSaveBlob) {
            this.downloadFileIE(file_path,file_name);
        }
        else if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
            if (!navigator.userAgent.match('CriOS') || ua.match(/iPhone/i)) {
                const myBlobContent = file_path.split(",")[1];
                // Determine MIME type from provided data URI (preferred) or file extension fallback
                let mime = 'application/octet-stream';
                if (file_path.startsWith('data:')) {
                    const m = file_path.substring(5, file_path.indexOf(';base64')); // data:<mime>;base64
                    if (m) mime = m;
                } else if (file_name) {
                    const ext = file_name.split('.').pop().toLowerCase();
                    const map = {
                        'xlsx':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'csv':'text/csv',
                        'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'pptx':'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                        'pdf':'application/pdf',
                        'png':'image/png',
                        'jpg':'image/jpeg',
                        'jpeg':'image/jpeg'
                    };
                    if (map[ext]) mime = map[ext];
                }
                let myBlob = new Blob([this.safariExportFile(myBlobContent, mime)], { type: mime });
                FileSaver.saveAs(myBlob, file_name);
            }
            else {
                let anchor_tag = document.createElement("a");
                anchor_tag.href = file_path;
                anchor_tag.download = file_name? file_name : file_path.split("/")[1];
                anchor_tag.className = "d-none";
                anchor_tag.id = "excel_link";
                if (file_path.split(".")[1] === "pdf")
                    anchor_tag.target = "_blank"
                document.querySelector("body").insertBefore(anchor_tag, null);
                setTimeout(() => {
                    document.getElementById("excel_link").click();
                    document.getElementById("excel_link").remove();
                }, 500)
            }
        }
        else {
            let anchor_tag = document.createElement("a");
            anchor_tag.href = file_path;
            anchor_tag.download = file_name? file_name : file_path.split("/")[1];
            anchor_tag.className = "d-none";
            anchor_tag.id = "excel_link";
            if (file_path.split(".")[1] === "pdf")
                anchor_tag.target = "_blank"
            document.querySelector("body").insertBefore(anchor_tag, null);
            setTimeout(() => {
                document.getElementById("excel_link").click();
                document.getElementById("excel_link").remove();
            }, 500)
        }
    }
    // Export a Excel and CSV file in safari.
    safariExportFile(base64Data, contentType) {
        contentType = contentType || '';
        let size = 1024;
        let charactersData = atob(base64Data);
        let byteLength = charactersData.length;
        let count = Math.ceil(byteLength / size);
        let base64DataBytesArrays = new Array(count);
        for (let index = 0; index < count; ++index) {
            let start = index * size;
            let end = Math.min(start + size, byteLength);
            let arrayLength = end - start;
            let blobBytes = new Array(arrayLength);
            var i=0;
            for (var offset = start; offset < end; ++offset) {
                blobBytes[i] = charactersData[offset].charCodeAt(0);
                ++i;
            }
            base64DataBytesArrays[index] = new Uint8Array(blobBytes);
        }
        return new Blob(base64DataBytesArrays, { type: contentType });
    }
    // download a Excel, CSV and PNG file in Internet Explorer.
    downloadFileIE(file_path,file_name='') {
        // IE 10+
        let filepath = file_name.split(";")[0];
        const b64Data = atob(file_path.split(",")[1]);
        var arraybuffer = new ArrayBuffer(b64Data.length);
        var getunitArray = new Uint8Array(arraybuffer);
        for (var i = 0; i < b64Data.length; i++) {
            getunitArray[i] = b64Data.charCodeAt(i);
        }
        navigator.msSaveBlob(new Blob([arraybuffer], { type: 'text/'+ filepath.split(".")[1] }), file_name);
    }
    downloadPdf(file_path, file_name='') {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var url = file_path;
        var fileName = (file_name) ? file_name : file_path.substring(file_path.lastIndexOf('/') + 1);
        // eslint-disable-next-line
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            var _window = window.open(url, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName)
            _window.close();
        }
        else {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(this.response);
                var tag = document.createElement('a');
                tag.href = imageUrl;
                tag.download = fileName;
                document.body.appendChild(tag);
                tag.click();
                document.body.removeChild(tag);
            }
            xhr.send();
        }
    }
    requestExcel = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/generateExcel/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    requestWord = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/SurveyQuestionsAsWord/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '/'+this.userId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    requestWordDiagram = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/SurveyResultChartsAsWord/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '/'+this.userId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    requestPowerpoint = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/SurveyResultChartsAsPowerpoint/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '/'+this.userId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    requestExcelforPlusPackage = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/SurveyResultAnalysisAsExcel/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '/'+this.userId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    requestCSV = async () => {
        let self = this;
        this.setState({
            loading: 'true'
        })
        if (this.surveyEditDataId) {
            if (this.surveyEditDataId && this.userData.token) {
                await axios.get(API_URL + '/surveyresult/generateCSV/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '?uId=' + this.userId, { headers: this.Api_request_header }).then((res) => {
                    this.createAnchorforDownload("data:" + res.data.file_type + ";base64," + res.data.success, res.data.file_name);
                    self.setState({
                        loading: 'false'
                    })
                }).catch((err) => {
                    console.log(err);
                    self.setState({
                        loading: 'false'
                    })
                })
            }
        }
    }
    Imagezip = async () => {
        // One-click flow: show full-screen loader, generate+upload images, then zip+download, then hide loader
        if (this.state.disablePDFButton) return; // double-click guard
        this.setState({ loading: 'true', disablePDFButton: true });
        
        try {
            this.processedQuestionIds = new Set();
            this.processedDemographicIds = new Set();
            this.isGeneratingZip = true;
            
            // Always generate/upload on demand so ZIP finds files
            await this.generateImagesForZip();

            const payload = {
                survey_id: this.surveyEditDataId,
                file_data: this.allImageGroups
            };
            const res = await axios.post(
                `${API_URL}/surveyresult/getPngfiles?uId=${this.userId}`,
                payload,
                { headers: this.Api_request_header }
            );

            const rawType = res?.data?.file_type || 'zip';
            const mime = typeof rawType === 'string' && rawType.indexOf('/') !== -1 ? rawType : `application/${rawType}`;
            const dataUri = `data:${mime};base64,${res.data.success}`;
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                download(dataUri, res.data.file_name, mime);
            } else if (navigator.msSaveBlob) {
                this.downloadFileIE(dataUri, res.data.file_name);
            } else {
                this.createAnchorforDownload(dataUri, res.data.file_name);
            }
        } catch (err) {
            console.log(err);
        } finally {
            this.isGeneratingZip = false;
            this.setState({ loading: 'false', disablePDFButton: false });
        }
    }

  // Generate and save all images to MinIO, then wait for completion
    generateImagesForZip = async (isRetry = false) => {
    // Ensure chart data is present before attempting generation to avoid first-click 404
    await this.ensureChartDataReady();
      
      // Reset counters
      if (!isRetry) {
          this.savedUploads = 0;
          this.totalGraphLength = 0;
          this.questionCount = 0;
          
          // Derive totalGraphLength similarly to componentDidMount
          if (this.state.demographicList && this.state.demographicList.length) {
              this.totalGraphLength = this.state.demographicList.length;
              this.questionCount = this.totalGraphLength;
          }
          if (this.state.questionList && this.state.questionList.length) {
              this.state.questionList.forEach((data) => {
                  if (data.question_type_id === 1 && (!data.tagcloud || !data.tagcloud.length)) {
                      return; // skip empty freetext
                  }
                  
                  if (data.question_type_id === 5 || data.question_type_id === 7) {
                      let optionCount = 0;
                      Object.keys(data).forEach(key => {
                          if (key.startsWith('data')) optionCount++;
                      });
                      this.totalGraphLength += optionCount;
                      this.questionCount += optionCount;
                  } else {
                      this.totalGraphLength += 1;
                      if (data.question_type_id !== 1) {
                          this.questionCount += 1;
                      }
                  }
              });
          }
      }
      
      // Kick off generation (uses existing sendImages to save to MinIO)
        try { await this.generateQuestionImages(isRetry); } catch(err) { console.warn('generateQuestionImages error:', err); }
        try { await this.generateDemographicImages(isRetry); } catch(err) { console.warn('generateDemographicImages error:', err); }
        
  }

  // Wait for question and demographic chart data to be loaded/render-available
  ensureChartDataReady = async (timeoutMs = 15000) => {
      const start = Date.now();
      return new Promise((resolve) => {
          const ok = () => {
              const ql = this.state.questionList;
              const dml = this.state.demographicList;
              const ssql = this.state.smallScreenQuestionList;
              const ssdl = this.state.smallScreenDemographicList;
              // Consider data ready if small-screen lists and main lists are present
              return Array.isArray(ql) && Array.isArray(dml) && Array.isArray(ssql) && Array.isArray(ssdl);
          };
          const tick = () => {
              if (ok()) return resolve(true);
              if (Date.now() - start > timeoutMs) return resolve(false);
              setTimeout(tick, 200);
          };
          tick();
      });
  }

    confirmDeleteParticipant = (id) => {
        let user_id = id;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <div className="close-btn text-right">
                            <button className="d-inline-block bg-white border-0 w-auto" onClick={onClose}><i className="ti-close pointer"></i></button>
                        </div>
                        <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['delete_message']}</p>
                        <button name="proceed_btn" onClick={(event) => {
                            this.deleteParticipant(user_id)
                            onClose()
                        }}>{MYPROFILE_SETTINGS_CONSTANT[LANGUAGE_CODE]['confirm_alert_yes_button_text']}</button>
                        <button onClick={onClose} >{MYPROFILE_SETTINGS_CONSTANT[LANGUAGE_CODE]['confirm_alert_no_button_text']}</button>
                    </div>
                )
            }
        })
    }
    deleteParticipant = async (id) => {
        this.setState({
            questionList: '', loading: 'true'
        }, async () => {
            let self = this;
            if (this.surveyEditDataId) {
                if (this.surveyEditDataId && id) {
                    await axios.delete(API_URL + "/surveyresult/deleteParticipantBySurveyIdAndUserId/" + LANGUAGE_CODE + "/" + this.surveyEditDataId + "/" + id + '?uId=' + this.userId, { headers: this.Api_request_header }).then(res => {
                        let participants = this.state.participated_user_list.userparticipated;
                        // eslint-disable-next-line
                        participants.map((user, index) => {
                            if (user.user_id === id) {
                                participants.splice(index, 1);
                                self.setState({ participants, send_chart_data: true })
                            }
                        })
                        self.componentDidMount();
                    }).catch(err => {
                        console.log(err);
                    })
                }
            }
        })
    }
    saveEditedChartImage = (image_string, image_name, chartData, data = []) => {
        if (!this.allImageGroups) this.allImageGroups = [];
    
        // Prepare image objects
        let imagesToAdd = [];
    
        if (chartData.question_type_id === 5 || chartData.question_type_id === 7) {
            imagesToAdd = data;
        } else {
            imagesToAdd = [{
                image_string: image_string?.replace("data:image/png;base64,", ""),
                image_name: image_name
            }];
        }
    
        // Add only unique images (avoid duplicates)
        imagesToAdd.forEach(img => {
            const alreadyExists = this.allImageGroups.some(
                g => g.image_name === img.image_name && g.image_string === img.image_string
            );
            if (!alreadyExists) {
                this.allImageGroups.push(img);
            }
        });
    };
    
    saveEditedChartImageDemographic = (image_string, image_name) => {
        if (!this.allImageGroups) this.allImageGroups = [];
    
        const image_meta = {
            image_string: image_string.replace("data:image/png;base64,", ""),
            image_name: image_name
        };
    
        // Add only if unique
        const alreadyExists = this.allImageGroups.some(
            g => g.image_name === image_meta.image_name && g.image_string === image_meta.image_string
        );
        if (!alreadyExists) {
            this.allImageGroups.push(image_meta);
        }
    };
    
    
    //To generate question PNG images
    generateQuestionImages = (isRetry = false) => {
        return new Promise((resolve) => {
            setTimeout(async () => {
                // eslint-disable-next-line
                if (this.state.questionList && this.state.questionList.length && this.state.smallScreenQuestionList) {
                    await this.state.questionList.reduce(async (prev, chart, index) => {
                        const res = await prev
              
                        if (isRetry && this.processedQuestionIds && this.processedQuestionIds.has(chart.question_id)) {
                            return res;
                        }
              
                        this.image_meta = {};
                        var dataOf57 = []
                        if (chart.hasOwnProperty("question_type_id") && chart.question_type_id === 1) {
                            var smallScreenQuestionList = this.state.smallScreenQuestionList[index]
                            let self = this;
                            let img_name = chart.question_id + "_" + ((chart && chart.question_title && chart.question_title.title)
                                ? (chart.question_title.title.length > 200)
                                    // eslint-disable-next-line
                                    ? chart.question_title.title.substring(0, 200).replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                    // eslint-disable-next-line
                                    : chart.question_title.title.replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                : chart.question_id + ".png");
                            img_name = img_name.replaceAll("ä", "ae");
                            img_name = img_name.replaceAll("ü", "ue");
                            img_name = img_name.replaceAll("ö", "oe");
                            img_name = img_name.replaceAll("Ü", "Ue");
                            img_name = img_name.replaceAll("Ä", "Ae");
                            img_name = img_name.replaceAll("Ö", "Oe");
                            img_name = img_name.replaceAll("ß", "ss");
                            if (chart.tagcloud.length) {
                                htmlToImage.toCanvas(document.getElementById("chart_div_" + index), { filter: this.filterHtmlImage, style: { 'font-family': 'sans-serif' } })
                                    .then(function (dataUrl) {
                                        self.saveEditedChartImage(dataUrl.toDataURL(), img_name, chart)
                                        // saveEditedImage(dataUrl.toDataURL(), chart, img_name, self.saveEditedChartImage, true, true,smallScreenQuestionList,dataUrl.toDataURL());
                                        if (!self.isGeneratingZip) {
                                            createChartDownloadLink("download_chart_div_" + index, chart.user_participated, true, chart, smallScreenQuestionList, true);
                                        }
                                    });
                            }
            
                            if (self.processedQuestionIds) {
                                self.processedQuestionIds.add(chart.question_id);
                            }
                        } else if (chart.hasOwnProperty("question_type_id") && (chart.question_type_id === 5 || chart.question_type_id === 7)) {
                            let keyArray = Object.keys(chart);
                            // eslint-disable-next-line
                            await keyArray.reduce(async (prevVal, value, array_index) => {
                                const newRes = await prevVal
                                value = keyArray[array_index]
                                if (value.substring(0, 4) === "data") {
                                    this.image_meta = {};
                                    var last_char = value.substring(4);
                                    let chart_options;
                                    let new_chart_options;
                                    if (chart.question_type_id === 7 || chart.question_type_id === 5) {
                                        chart_options = chart["option" + last_char]
                                        chart_options = { ...chart_options, colors: ['red'] }
                                        new_chart_options = this.state.smallScreenQuestionList[index]["option" + last_char]
                                    } else {
                                        // eslint-disable-next-line
                                        chart_options = chart.options;
                                        chart_options = { ...chart_options, colors: ['red'] }
                                        new_chart_options = this.state.smallScreenQuestionList[index].options;
                                    }
                                    let isLast = (keyArray.length - 1 === array_index);
                                    let img_name = chart.question_id + "_" + chart_options.option_id + "_" + ((chart_options && chart_options.title)
                                        ? (chart_options.title.length > 200)
                                            // eslint-disable-next-line
                                            ? chart_options.title.substring(0, 200).replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                            // eslint-disable-next-line
                                            : chart_options.title.replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                        : chart.question_id + "_opt_" + value + ".png");
                                    new_chart_options['title'] = chart_options.title
                                    let chart_new_data = { 'data': chart[value], 'options': chart_options, "user_participated": chart['user_participated'] }
                                    let chart_new_new_data = { 'data': this.state.smallScreenQuestionList[index][value], 'options': new_chart_options, "user_participated": chart['user_participated'] }
                                    img_name = img_name.replaceAll("ä", "ae");
                                    img_name = img_name.replaceAll("ü", "ue");
                                    img_name = img_name.replaceAll("ö", "oe");
                                    img_name = img_name.replaceAll("Ü", "Ue");
                                    img_name = img_name.replaceAll("Ä", "Ae");
                                    img_name = img_name.replaceAll("Ö", "Oe");
                                    img_name = img_name.replaceAll("ß", "ss");
                                    if (!this.isGeneratingZip) {
                                        createChartDownloadLink("download_chart_div_opt_" + value + "_" + index, chart.user_participated, false, chart_new_data, chart_new_new_data, true);
                                    }
                                    let newImageDataString = await getActualImageString(this.state.smallScreenQuestionList[index], last_char)
                                    this.image_meta['image_string'] = newImageDataString.replace("data:image/png;base64,", "");
                                    this.image_meta['image_name'] = img_name;
                                    dataOf57.push(this.image_meta)
                                    if (isLast) {
                                        this.saveEditedChartImage(newImageDataString, img_name, chart, dataOf57)
                                        if (this.processedQuestionIds) {
                                            this.processedQuestionIds.add(chart.question_id);
                                        }
                                    }
                                }
                                return newRes
                            }, [])
                        }
                        else {
                            this.image_meta = {};
                            let img_name = chart.question_id + "_" + ((chart && chart.options && chart.options.title)
                                ? (chart.options.title.length > 200)
                                    // eslint-disable-next-line
                                    ? chart.options.title.substring(0, 200).replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                    // eslint-disable-next-line
                                    : chart.options.title.replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                : chart.question_id + ".png");
                            img_name = img_name.replaceAll("ä", "ae");
                            img_name = img_name.replaceAll("ü", "ue");
                            img_name = img_name.replaceAll("ö", "oe");
                            img_name = img_name.replaceAll("Ü", "Ue");
                            img_name = img_name.replaceAll("Ä", "Ae");
                            img_name = img_name.replaceAll("Ö", "Oe");
                            img_name = img_name.replaceAll("ß", "ss");
                            if (!this.isGeneratingZip) {
                                createChartDownloadLink("download_chart_div_" + index, chart.user_participated, false, chart, this.state.smallScreenQuestionList[index], true);
                            }
                            let newImageDataString = await getActualImageString(this.state.smallScreenQuestionList[index], '')
                            this.saveEditedChartImage(newImageDataString, img_name, chart)
                
                            if (this.processedQuestionIds) {
                                this.processedQuestionIds.add(chart.question_id);
                            }
                        }
                        if (index === (this.state.questionList.length - 1)) {
                            this.setState({ showNormalQuestionLoader: false })                                
                            resolve(true);
                        }
                        return res
                    }, [])
                } else {
                    resolve(true)
                }
                this.setState({ showNormalQuestionLoader: false, showImageZipLoader: false, disablePDFButton: false })
            }, 3000)            
        })
    }
    //To generate demographic question PNG images
    generateDemographicImages = (isRetry = false) => {
        return new Promise((resolve) => {
            setTimeout(async () => {
                // eslint-disable-next-line
                if (this.state.demographicList && this.state.demographicList.length && this.state.smallScreenDemographicList) {
                    await this.state.demographicList.reduce(async (prev, chart, index) => {
                        const res = await prev
                        
                        if (isRetry && this.processedDemographicIds && this.processedDemographicIds.has(chart.demographic_id)) {
                            return res;
                        }
                    
                        // eslint-disable-next-line
                        if (chart.hasOwnProperty("question_type_id") && (chart.question_type_id === 5 || chart.question_type_id === 7)) {
                        }
                        else {
                            let img_name = chart.demographic_id + "_" + (chart.options && chart.options.title
                                ? (chart.options.title.length > 200)
                                    // eslint-disable-next-line
                                    ? chart.options.title.substring(0, 200).replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                    // eslint-disable-next-line
                                    : chart.options.title.replace(/[?]/g, "").replace(/[!@#$%^&*"€()?',.|=]/g, "_").replace(/\s/g, '_').replace(/\//g, '_').replace(/[&\/\\#, +()$~%.'"*?<>{}`-]/g, '_').replace(/[\[\]']/g, '_') + ".png"
                                : "demographic_" + chart.demographic_id + ".png");
                            img_name = img_name.replaceAll("ä", "ae");
                            img_name = img_name.replaceAll("ü", "ue");
                            img_name = img_name.replaceAll("ö", "oe");
                            img_name = img_name.replaceAll("Ü", "Ue");
                            img_name = img_name.replaceAll("Ä", "Ae");
                            img_name = img_name.replaceAll("Ö", "Oe");
                            img_name = img_name.replaceAll("ß", "ss");
                            if (!this.isGeneratingZip) {
                                createChartDownloadLink("download_chart_div_demographic_" + index, chart.user_participated, false, chart, this.state.smallScreenDemographicList[index], true)
                            }
                            let newImageDataString = await getActualImageString(this.state.smallScreenDemographicList[index], '')
                            this.saveEditedChartImageDemographic(newImageDataString, img_name)
                        
                            if (this.processedDemographicIds) {
                                this.processedDemographicIds.add(chart.demographic_id);
                            }
                        }
                
                        if (index === (this.state.demographicList.length - 1)) {
                            this.setState({ showDemoGraphQuestionLoader: false });
                            resolve(true)
                        }    
                        return res
                    }, [])
                } else {
                    resolve(true)
                }
                this.setState({ showDemoGraphQuestionLoader: false, showImageZipLoader: false, disablePDFButton: false })
            }, 3000)
        })
    }
    generateChartImagesZip = () => {
        // Intentionally left inert; generation occurs only when users click download actions.
    }

    // Determine if required chart data is ready for image generation
    isChartDataReady = () => {
        const { questionList, demographicList, smallScreenQuestionList, smallScreenDemographicList } = this.state;
        return Array.isArray(questionList) && Array.isArray(demographicList) && Array.isArray(smallScreenQuestionList) && Array.isArray(smallScreenDemographicList);
    }

    // If ready and currently disabled, enable the Speichern (chart images ZIP) button
    updateChartImagesZipReadyIfDataLoaded = () => {
        if (this.state.chartImagesZipDisabled && this.isChartDataReady()) {
            this.setState({ chartImagesZipDisabled: false });
        }
    }
    
    handleChangeToggle = async (event) => {
        const value = event.target.checked;
        this.setState({
            analysisDataViewType: value
        }, async () => {
            await this.handleCrossTableDataChange();
        });
    }
    getQuestionDropdown = async () => {
        this.setState({
            questionId1SelectedIndex: 0,
            questionId2SelectedIndex:  0
        })
        let questionData = {};
        let questionOptionData = {};
        // eslint-disable-next-line
        let questionArray = new Array();
        if (this.surveyEditDataId && this.userData.token && this.userId) {
            // Show loader while we prepare dropdowns and initial table
            await new Promise(resolve => {
                this.setState({ tableLoading: true }, resolve);
            });
            await this.handleAnalyseAssistentTable();
            await axios.get(API_URL + '/surveyresult/getdropdownforcrosstabbulationdata/' + LANGUAGE_CODE + '/' + this.surveyEditDataId + '/' + this.userId + '?uId=' + this.userId, { headers: this.Api_request_header })
                .then((response) => {
                    let dropdownData = response.data['success'].dropdwondata;
                    if (dropdownData['demographicQuestionData']) {
                        // eslint-disable-next-line
                        dropdownData['demographicQuestionData'].map((data) => {
                            questionData = {
                                'id': data.demographic_id,
                                'text': data.question,
                                'isQuestionDemographic': 1
                            }
                            questionArray.push(questionData);
                        })
                    }
                    if (dropdownData['surveyquestionData']) {
                        // eslint-disable-next-line
                        dropdownData['surveyquestionData'].map((data) => {
                            questionData = {
                                'id': data.id,
                                'text': data.question_text,
                                'isQuestionDemographic': 0
                            }
                            if (data.option) {
                                // eslint-disable-next-line
                                questionData['option'] = new Array();
                                // eslint-disable-next-line
                                data.option.map((optionData) => {
                                    questionOptionData = {
                                        'id': optionData.id,
                                        'text': optionData.option_text
                                    }
                                    questionData['option'].push(questionOptionData);
                                })
                            }
                            questionArray.push(questionData);
                        })
                    }
                    // eslint-disable-next-line
                    this.state.questionArray = questionArray;
                })
                .catch((error) => {
                    if (error && error.response && error.response.data) {
                        let msg = error.response.data['error']
                        if (msg === 'Invalid User') {
                            // eslint-disable-next-line
                            this.state.redirectTo404 = true
                        }
                    }
                })
                await new Promise(resolve => {
                    this.setState({ tableLoading: false }, resolve);
                });
                await this.handleCrossTableDataChange();
        }
    }
    handleCrossTableDataChange = async (event) => {
        let questionId1SelectedIndex = this.state.questionId1SelectedIndex;
        let questionId2SelectedIndex = this.state.questionId2SelectedIndex;
        if (event && event.target.id === 'questionId1') {
            // eslint-disable-next-line
            this.state.isQ1Demographic = event.target[event.target.selectedIndex].getAttribute('data-isdemographic');
            questionId1SelectedIndex = event.target.selectedIndex
            // eslint-disable-next-line
            this.state.aspectId1 = undefined;
        }
        if (event && event.target.id === 'questionId2') {
            // eslint-disable-next-line
            this.state.isQ2Demographic = event.target[event.target.selectedIndex].getAttribute('data-isdemographic');
            questionId2SelectedIndex = event.target.selectedIndex
            // eslint-disable-next-line
            this.state.aspectId2 = undefined;
        }
        if (event && event.target.id === 'aspectId1') {
            // eslint-disable-next-line
            this.state.aspectId1 = event.target.value;
        }
        if (event && event.target.id === 'aspectId2') {
            // eslint-disable-next-line
            this.state.aspectId2 = event.target.value;
        }
        let questionArray = this.state.questionArray;
        // Derive selected question ids from event/state rather than querying DOM, to work while loader is shown
        const derivedQ1 = (event && event.target.id === 'questionId1')
            ? event.target.value
            : (this.state.questionId1 || questionArray[0]?.id);
        const derivedQ2 = (event && event.target.id === 'questionId2')
            ? event.target.value
            : (this.state.questionId2 || ((questionArray[1]?.id) ? (questionArray[1]?.id) : (questionArray[0]?.id)));
        this.setState({
            questionId1: derivedQ1,
            questionId2: derivedQ2,
            isQ1Demographic: this.state.isQ1Demographic != undefined ? this.state.isQ1Demographic : questionArray[0]?.isQuestionDemographic,
            isQ2Demographic:  this.state.isQ2Demographic != undefined ? this.state.isQ2Demographic : ((questionArray[1]?.isQuestionDemographic) ? (questionArray[1]?.isQuestionDemographic) : (questionArray[0]?.isQuestionDemographic)),
            questionId1SelectedIndex: questionId1SelectedIndex,
            questionId2SelectedIndex:  questionId2SelectedIndex
        }, async () => {
            if(this.state.aspectId1 == undefined) {
                for (let i = 0; i < questionArray.length; i++) {
                    if (questionArray[i].id == this.state.questionId1 && questionArray[i].option) {
                        // eslint-disable-next-line
                        this.state.aspectId1 = questionArray[i].option[0].id;
                        break;
                    }
                }
            }
            if(this.state.aspectId2 == undefined) {
                for (var i = 0; i < questionArray.length; i++) {
                    if (questionArray[i].id == this.state.questionId2 && questionArray[i].option) {
                        // eslint-disable-next-line
                        this.state.aspectId2 = questionArray[i].option[0].id;
                        break;
                    }
                }
            }
            // Show loading animation while fetching new crosstab data
            await new Promise(resolve => {
                this.setState({ tableLoading: true }, resolve);
            });
            // Immediately render the loader inside the modal so users see feedback during fetch
            await this.handleAnalyseAssistentTable();
            // Build request URL
            let urlString = API_URL + 
                '/surveyresult/getcrosstabulationanalysisdata/' + 
                LANGUAGE_CODE + '/' + 
                this.surveyEditDataId + '/' + 
                this.userId + 
                '?uId=' + this.userId +
                '&question1=' + this.state.questionId1 + 
                '&question2=' + this.state.questionId2 + 
                '&isquestion1demographic=' + this.state.isQ1Demographic + 
                '&isquestion2demographic=' + this.state.isQ2Demographic + 
                '&aspect1=' + this.state.aspectId1 + 
                '&aspect2=' + this.state.aspectId2;
            urlString += '&isPercentage=' + (this.state.analysisDataViewType ? 0 : 1);
            await axios.get(urlString, { headers: this.Api_request_header })
                .then((response) => {
                    // Update table rows with the response
                    this.setState({
                        crossTabulationData: response.data['success'].crosstabulationdata
                    });
                })
                .catch((error) => {
                    if (error && error.response && error.response.data) {
                        let msg = error.response.data['error']
                        if (msg === 'Invalid User') {
                            // eslint-disable-next-line
                            this.state.redirectTo404 = true
                        }
                    }
                })
            // Hide loader and re-render popup with the new table
            await new Promise(resolve => {
                this.setState({ tableLoading: false }, resolve);
            });
            await this.handleAnalyseAssistentTable();
            if (this.userData.plan_type == null && (questionId1SelectedIndex == 0 || questionId1SelectedIndex == 1) && (questionId2SelectedIndex == 0 || questionId2SelectedIndex == 1)) {
                document.getElementById('unlock-analyse-button').setAttribute('hidden',true);
                document.getElementById('analysis-result-table').style.maskImage = 'none';
                document.getElementById('analysis-result-table').style.height = 'unset';
                document.getElementById('analysis-result-table').style.overflow = 'auto';
            }else if (this.userData.plan_type == null) {
                document.getElementById('unlock-analyse-button').removeAttribute('hidden');
                document.getElementById('analysis-result-table').style.maskImage = 'linear-gradient(to bottom, rgba(211,211,211,0.4), rgba(0,0,0,0))';
                document.getElementById('analysis-result-table').style.height = '150px';
                document.getElementById('analysis-result-table').style.overflow = 'hidden';
            }
        });        
    }
    handleAnalyseAssistentTable = async () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-left position-relative share_popup' id="analyse-assistent-table">
                        <div style={{"--select-icon" : "url("+IMAGE_BASEURL+"img/down-arrow.png)", "--effect" : "url(" + IMAGE_BASEURL + "img/home-about-texture.svg)"}}>
                        <div className="close-btn text-right">
                            <button className="d-inline-block bg-white border-0 w-auto sharing-close-button text-rgb" onClick={onClose}><i className="ti-close pointer"></i></button>
                        </div>
                        <h3 className="font-24 text-dark mt-2 mt-sm-0 font-weight-bold text-left survey-sharing-bottom-margin">{SURVEY_ANALYSIS[LANGUAGE_CODE]['analyse_assistent_heading']}</h3>
                        <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['analyse_assistent_sub_heading']}</p>
                        <div className="row">
                            <div className="col-12 col-md">
                                <div className="input-group mb-3">
                                    <select className="custom-select" defaultValue={this.state.questionId1} onChange={this.handleCrossTableDataChange} id="questionId1" disabled={this.state.tableLoading}>
                                    {this.state.questionArray.map((question, index) => {
                                        if (question?.id == this.state.questionId1 && question?.isQuestionDemographic == this.state.isQ1Demographic) {
                                            // eslint-disable-next-line
                                            this.state.question1Options = '';
                                            if (question?.option) {
                                                // eslint-disable-next-line
                                                this.state.question1Options = question?.option;
                                            }
                                        }
                                        return (<option value={question?.id} key={index} data-isdemographic={question?.isQuestionDemographic}>{(index+1)+'. '+question?.text}</option>)
                                    })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md">
                                <div className="input-group mb-3">
                                    <select className="custom-select" defaultValue={this.state.questionId2} onChange={this.handleCrossTableDataChange} id="questionId2" disabled={this.state.tableLoading}>
                                    {this.state.questionArray.map((question, index) => {
                                        if (question?.id == this.state.questionId2 && question?.isQuestionDemographic == this.state.isQ2Demographic) {
                                            // eslint-disable-next-line
                                            this.state.question2Options = '';
                                            if (question?.option) {
                                                // eslint-disable-next-line
                                                this.state.question2Options = question?.option;
                                            }
                                        }
                                        return (<option value={question?.id} key={index} data-isdemographic={question?.isQuestionDemographic}>{(index+1)+'. '+question?.text}</option>)
                                    })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md">
                                <div className="input-group mb-3">
                                    {this.state.question1Options &&
                                        <select className="custom-select" defaultValue={this.state.aspectId1} onChange={this.handleCrossTableDataChange} id="aspectId1" disabled={this.state.tableLoading}>
                                        {this.state.question1Options.map((question, index) => {
                                            return (<option value={question?.id} key={index}>{question?.text}</option>)
                                        })}
                                        </select>
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md">
                                <div className="input-group mb-3">
                                    {this.state.question2Options &&
                                        <select className="custom-select" defaultValue={this.state.aspectId2} onChange={this.handleCrossTableDataChange} id="aspectId2" disabled={this.state.tableLoading}>
                                        {this.state.question2Options.map((question, index) => {
                                            return (<option value={question?.id} key={index}>{question?.text}</option>)
                                        })}
                                        </select>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="swich-slider d-flex align-items-center mt-2">
                            <div className="text-dark">{SURVEY_ANALYSIS[LANGUAGE_CODE]['analyse_assistent_switch_1']}</div>&nbsp;
                            <label className="switch">
                                <input type="checkbox" data-toggle="toggle" name="analysis_data_view_type" onChange={this.handleChangeToggle} checked={this.state.analysisDataViewType} disabled={this.state.tableLoading} />
                                <span className="slider round btn-bgcolor"></span>
                            </label>&nbsp;
                            <div className="text-dark">{SURVEY_ANALYSIS[LANGUAGE_CODE]['analyse_assistent_switch_2']}</div>
                        </div>
                        { (this.state.crossTabulationData).length == 0 && !this.state.tableLoading ? (
                            <div className="text-center my-3 mt-md-4 mb-md-4">
                                <p class="font-18 text-dark font-weight-bold pt-5 pb-0 mb-0">Keine Daten Verfügbar</p>
                            </div>
                        ) : null }
                        <div className={"text-center my-3 mt-md-4 mb-md-4 "+((this.state.crossTabulationData).length == 0 ? "pt-0 pb-0" : null)} id="unlock-analyse-button" hidden>
                            <a href={this.userData.account_type_category_id == 4? "/business-checkout" : this.userData.account_type_category_id == 2? "/university-checkout" : "/checkout"}><button type="button" name="unlock_analyse_button" className="btn btn-clr text-white text-uppercase font-18" onClick={() => localStorage.setItem('redirectURL',window.location.href)} title={SURVEY_ANALYSIS[LANGUAGE_CODE]['unlock_analyse_button']} >{SURVEY_ANALYSIS[LANGUAGE_CODE]['unlock_analyse_button']}</button></a>
                        </div>
                        <div className="table-responsive table-participants mt-4 pt-0 position-relative" id="analysis-result-table">
                            {this.state.tableLoading && (
                                <div className="w-100 d-flex align-items-center justify-content-center my-3" style={{minHeight:'120px'}}>
                                    {TABLE_LOADING}
                                </div>
                            )}
                            <table className="member-table" style={{display: this.state.tableLoading ? 'none' : 'table'}}>
                                <tbody>
                                {
                                    (this.state.crossTabulationData).length > 0 && this.state.crossTabulationData.map((row,index) => {
                                        return (
                                            <tr>
                                                {row && row.map((data,rowIndex) => {
                                                    return (<td className={(index == 0 || rowIndex == 0) ?"font-weight-bold":""} style={{minWidth:(index !== 0 && rowIndex == 0)?'115px':'unset'}}>{data}</td>)})}
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                            {(this.state.crossTabulationData && this.state.crossTabulationData.length > 0) && (
                                <div className="d-flex justify-content-end align-items-center mt-2 mb-0 pr-0">
                                    <div className="d-flex align-items-center mr-3" style={{cursor:'pointer'}} onClick={this.exportCrossTabToExcel}>
                                        <p className="mb-0 mr-1"><i className="ti-download text-primary"></i></p>
                                        <p className='Download_btn_text_dark mb-0'>Excel</p>
                                    </div>
                                    <div className="d-flex align-items-center" style={{cursor:'pointer'}} onClick={this.exportCrossTabToCSV}>
                                        <p className="mb-0 mr-1"><i className="ti-download text-primary"></i></p>
                                        <p className='Download_btn_text_dark mb-0'>CSV</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    </div>
                )
            }
        })
    }
    resetViewers = () => {
        this.setState({loading : 'true'})
        this.Api_request_header = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.userData.token
        }
        var surveyEditDataId = (this.props.match.params.surveyid) ? window.atob(this.props.match.params.surveyid) : '';
        var userid = this.userData ? this.userData.id : "";
        axios.get(API_URL + "/surveyresult/ResetSurveyImpressions/" + LANGUAGE_CODE + "/" + surveyEditDataId + '?uId=' + userid, { headers: this.Api_request_header }).then(res => {
            if (res.data) {
                // eslint-disable-next-line
                this.state.surveyData.totaluservisited  = res.data.success.ResetSurveyImpressions ? 0  : this.state.surveyData.totaluservisited
            }
            this.componentDidMount();
        }).catch(err => {
            console.log(err);
            this.setState({loading:'false'})
        })
    }
    handleReset = (e) => {
        e.preventDefault()
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui position-relative share_popup'>
                            <div className="close-btn text-right">
                                <button className="d-inline-block bg-white border-0 w-auto sharing-close-button text-rgb" onClick={onClose}><i className="ti-close pointer"></i></button>
                            </div>
                            <h3 className="font-24 text-dark mt-2 mt-sm-0 font-weight-bold text-left survey-sharing-bottom-margin">{SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_heading']}</h3>
                            <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_title']}</p>
                            <button name="left_button" type="button" onClick={onClose} title={SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_left_button']}>{SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_left_button']}</button>
                            <button name="right_button" type="button" onClick={e => {this.resetViewers()
                                onClose()}} className="reset-button" title={SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_right_button']}>{SURVEY_ANALYSIS[LANGUAGE_CODE]['reset_right_button']}</button>
                        </div>
                )
            }
        })
    }
    render() {
        var user_ID= null;
        if(this.userData){
            user_ID = this.userData.account_type_category_id
        }
        return (
            <React.Fragment>
                {(!JSON.parse(localStorage.getItem("userdata"))) ? <Redirect to="/anmelden-alt" /> : null}
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                {(this.state.redirectTo404 === true) ?
                    <Redirect to="/404" />
                    : null
                }
                <div className={localStorage.getItem("editsurveyactivetab") === "2" ? "tab-pane fade active show" : "tab-pane fade"} id="auswerten" role="tabpanel" aria-labelledby="auswerten-tab">
                    <div className="analyze-tab">
                        <div className="container-md pl-0 pr-0">
                            <div className="row">
                                <div className="col-12">
                                    <div className="count-box counter auto-height bg-white box-shadow">
                                        <div className="row no-gutters">
                                            <div className="col-12 col-md pt-3 pt-md-0 counter-border">
                                                <div className="counter-col  counter-font">
                                                    <div className="counter-data custom-static-data">
                                                        <div className="count" data-to="245" data-speed={this.state.surveyData.totaluserparticipated}>{this.state.surveyData.totaluserparticipated && this.props.showCounter 
                                                            ? <CountUp end={this.state.surveyData.totaluserparticipated} /> 
                                                            : 0}
                                                        </div>
                                                        <h6 className="font-18 text-truncate">{SURVEY_ANALYSIS[LANGUAGE_CODE]['member']}</h6>
                                                    </div>
                                                </div> {/*<!-- count col -->*/}
                                            </div>
                                            <div className="col-12 col-md pt-3 pt-md-0 counter-border">
                                                <div className="counter-col counter-font">
                                                    <div className="counter-data custom-static-data">
                                                        <div className="count" data-to="189" data-speed={this.state.surveyData.usercompletedsurvey}>{this.state.surveyData.usercompletedsurvey && this.props.showCounter 
                                                            ? <CountUp end={this.state.surveyData.usercompletedsurvey} />  
                                                            : 0}
                                                        </div>
                                                        <h6 className="font-18 text-truncate">{SURVEY_ANALYSIS[LANGUAGE_CODE]['member_from_empirio']}</h6>
                                                    </div>
                                                </div>{/* <!-- count col -->*/}
                                            </div>
                                            <div className="col-12 col-md pt-3 pt-md-0 counter-border">
                                                <div className="counter-col counter-font">
                                                    <div className="counter-data custom-static-data">
                                                        <div className="count" data-to="445" data-speed={this.state.surveyData.totaluservisited ? this.state.surveyData.totaluservisited : 0}>
                                                            {this.state.surveyData.totaluservisited && this.props.showCounter 
                                                                ? <CountUp end={this.state.surveyData.totaluservisited} /> 
                                                                : 0
                                                            }
                                                        </div>
                                                        {/* eslint-disable-next-line */}
                                                        <h6 className="font-18 text-truncate">{SURVEY_ANALYSIS[LANGUAGE_CODE]['views']}</h6><a href="#" onClick={(e)=>this.handleReset(e)}>{SURVEY_ANALYSIS[LANGUAGE_CODE]['reset']}</a>
                                                    </div>
                                                </div>{/* <!-- count col -->*/}
                                            </div>
                                            <div className="col-12 col-md pt-3 pt-md-0 counter-border">
                                                <div className="counter-col counter-font">
                                                    <div className="counter-data custom-static-data">
                                                        <span className="count" data-to="6" data-speed={this.state.surveyData.averageduration && this.state.surveyData.averageduration.minute ? this.state.surveyData.averageduration.minute : 0}>
                                                            {(this.state.surveyData.averageduration && this.state.surveyData.averageduration.minute && this.props.showCounter)
                                                                ? <CountUp formattingFn={(n) => (n<10)?"0"+n:n} end={this.state.surveyData.averageduration.minute} /> 
                                                                : "00"
                                                            }</span>
                                                        <span className="count">:</span>
                                                        <span className="count" data-to="6" data-speed={this.state.surveyData.averageduration && this.state.surveyData.averageduration.second ? this.state.surveyData.averageduration.second : 0}>
                                                            {(this.state.surveyData.averageduration && this.state.surveyData.averageduration.second && this.props.showCounter)
                                                                ? <CountUp formattingFn={(n) => (n<10)?"0"+n:n} end={this.state.surveyData.averageduration.second} />
                                                                : "00"
                                                            } min</span>
                                                        <h6 className="font-18 text-truncate">{SURVEY_ANALYSIS[LANGUAGE_CODE]['duration']}</h6>
                                                    </div>
                                                </div>{/* <!-- count col -->*/}
                                            </div>
                                            <div className="col-12 col-md pt-3 pt-md-0">
                                                <div className="counter-col counter-font">
                                                    <div className="counter-data custom-static-data">
                                                        <div className="count" data-to="20" data-speed={this.state.surveyData.visitedwelcomepageUser}>{this.state.surveyData.visitedwelcomepageUser && this.props.showCounter 
                                                            ? <CountUp end={this.state.surveyData.visitedwelcomepageUser} /> 
                                                            : 0}
                                                        %</div>
                                                        <h6 className="font-18 text-truncate">{SURVEY_ANALYSIS[LANGUAGE_CODE]['dropout_rate']}</h6>
                                                    </div>
                                                </div>{/* <!-- count col -->*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white box-shadow mt-5">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-content bg-white">
                                            <h3 className="mb-0 text-dark font-weight-bold text-break mt-4">{SURVEY_ANALYSIS[LANGUAGE_CODE]['download_result']}</h3>
                                            <div className="bottom-border-blue-auswerten mt-2"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="Download_btn_container">
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-excel download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['excel']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer" onClick={this.state.isZeroParticipants ? 'false' : this.requestExcel}>
                                            {
                                                !this.state.isZeroParticipants ? this.state.isExcelBtnDisabled
                                                ? <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary cursor-pointer" onClick='false'></i></p>
                                                : <p><i className="ti-download text-primary"></i></p>
                                                : <p><i className="ti-download Download_btn_text_grey" onClick='false'></i></p>
                                            }
                                            {
                                                !this.state.isZeroParticipants ? this.state.isExcelBtnDisabled
                                                ? <p className ='Download_btn_text_dark opacity-60' onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p className ='Download_btn_text_dark opacity-60' onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-powerpoint download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['powerpoint']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                            {  this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? (this.state.isPremiumExportBtnDisabled ?
                                                    <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary" onClick='false'></i></p>
                                                    : <p><i class="ti-download text-primary" onClick={this.requestPowerpoint}></i></p>)
                                                : <p><i class="ti-download Download_btn_text_grey" onClick='false'></i></p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><i onClick={() => localStorage.setItem('redirectURL',window.location.href)} class="ti-lock lock_btn_text_grey font-weight-bold"></i></Link></p>
                                            }
                                            {   this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? <p className={this.state.isPremiumExportBtnDisabled ? "border-0 bg-transparent text-dark font-weight-bold opacity-60" :"border-0 bg-transparent text-dark font-weight-bold"}
                                                     onClick={this.state.isPremiumExportBtnDisabled ? 'false' :this.requestPowerpoint}>
                                                     {SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}
                                                  </p>
                                                : <p className="border-0 bg-transparent text-dark font-weight-bold opacity-60" onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><span onClick={() => localStorage.setItem('redirectURL',window.location.href)} className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</span></Link></p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-csv download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['csv']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer" onClick={this.state.isZeroParticipants ? 'false' : this.requestCSV}>
                                            {
                                                !this.state.isZeroParticipants ? this.state.isCSVBtnDisabled
                                                ? <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary cursor-pointer" onClick='false'></i></p>
                                                : <p><i className="ti-download text-primary"></i></p>
                                                : <p><i className="ti-download Download_btn_text_grey" onClick='false'></i></p>
                                            }
                                            {
                                                !this.state.isZeroParticipants ? this.state.isCSVBtnDisabled
                                                ? <p className ='Download_btn_text_dark opacity-60' onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p className ='Download_btn_text_dark opacity-60' onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-word download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['word_diagramme']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                            {  this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? (this.state.isPremiumExportBtnDisabled ?
                                                    <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary"></i></p>
                                                    : <p><i class="ti-download text-primary" onClick={this.requestWordDiagram}></i></p>)
                                                : <p><i class="ti-download Download_btn_text_grey" onClick='false'></i></p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><i onClick={() => localStorage.setItem('redirectURL',window.location.href)} class="ti-lock lock_btn_text_grey font-weight-bold"></i></Link></p>
                                            }
                                            { this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? <p className={this.state.isPremiumExportBtnDisabled ? "border-0 bg-transparent text-dark font-weight-bold opacity-60" :"border-0 bg-transparent text-dark font-weight-bold"}
                                                     onClick={this.state.isPremiumExportBtnDisabled ? 'false' :this.requestWordDiagram}>
                                                    {SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}
                                                  </p>
                                                : <p className="border-0 bg-transparent text-dark font-weight-bold opacity-60" onClick='false' >{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><span onClick={() => localStorage.setItem('redirectURL',window.location.href)} className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</span></Link></p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-image download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['png']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer" onClick={this.userData.plan_type && !this.state.chartImagesZipDisabled && !this.state.disablePDFButton ? this.Imagezip : 'false'}>
                                            {
                                                this.userData.plan_type
                                                    ? (
                                                        this.state.chartImagesZipDisabled
                                                            ? <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary"></i></p>
                                                            : <p><i className="ti-download text-primary"></i></p>
                                                      )
                                                    : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><i onClick={() => localStorage.setItem('redirectURL',window.location.href)} class="ti-lock lock_btn_text_grey font-weight-bold"></i></Link></p>
                                            }
                                            {
                                                this.userData.plan_type
                                                    ? <p className={'Download_btn_text_dark' + (this.state.chartImagesZipDisabled ? ' opacity-60' : '')}>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                    : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><span onClick={() => localStorage.setItem('redirectURL',window.location.href)} className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</span></Link></p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-word download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['word_fragbook']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                                {  this.userData.plan_type
                                                    ?
                                                    <>
                                                        <p><i class="ti-download text-primary" onClick={this.requestWord}></i></p>
                                                        <p className="border-0 bg-transparent text-dark font-weight-bold" onClick={this.requestWord}>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                    </>
                                                    :
                                                    <>
                                                        <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><i class="ti-lock lock_btn_text_grey font-weight-bold" onClick={() => localStorage.setItem('redirectURL',window.location.href)}></i></Link></p>
                                                        <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><span onClick={() => localStorage.setItem('redirectURL',window.location.href)} className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</span></Link></p>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-file-excel download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['premium_excel']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                            { this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? (this.state.isPremiumExportBtnDisabled ?
                                                    <p><i className="fa fa-spinner fa-spin font-weight-bold text-primary"></i></p>
                                                    : <p><i class="ti-download text-primary" onClick={this.requestExcelforPlusPackage}></i></p>)
                                                : <p><i class="ti-download Download_btn_text_grey" onClick='false'></i></p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><i class="ti-lock lock_btn_text_grey font-weight-bold" onClick={() => localStorage.setItem('redirectURL',window.location.href)}></i></Link></p>
                                            }
                                            { this.userData.plan_type ? !this.state.isZeroParticipants
                                                ? <p className={this.state.isPremiumExportBtnDisabled ? "border-0 bg-transparent text-dark font-weight-bold opacity-60" :"border-0 bg-transparent text-dark font-weight-bold"} disabled={this.state.isPremiumExportBtnDisabled}
                                                     onClick={this.state.isPremiumExportBtnDisabled ? 'false' :this.requestExcelforPlusPackage}>
                                                     {SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}
                                                  </p>
                                                : <p className="border-0 bg-transparent text-dark font-weight-bold opacity-60" onClick='false'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</p>
                                                : <p><Link to={user_ID == 4 ? '/business-checkout' : user_ID == 2 ? "/university-checkout" : '/checkout'}><span onClick={() => localStorage.setItem('redirectURL',window.location.href)} className ='Download_btn_text_dark'>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['canvasDownloadButtonLabel']}</span></Link></p>
                                            }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Download_btn_item">
                                        <div className="download_btn_border-bottom d-flex justify-content-between">
                                            <div className="d-flex">
                                                <p><i className="fas fa-table download_btn_file_icon"></i></p>
                                                <p>{SURVEY_ANALYSIS[LANGUAGE_CODE]['analyse_assistent']}</p>
                                            </div>
                                            <div className="d-flex cursor-pointer">
                                                <p className ='Download_btn_text_dark' onClick={() => this.getQuestionDropdown()}>{SURVEY_PARTICIPATION[LANGUAGE_CODE]['analyse_assistent_link']}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white box-shadow table-main-block mt-5">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-content bg-white">
                                            <h3 className="mb-0 text-dark font-weight-bold text-break">{SURVEY_ANALYSIS[LANGUAGE_CODE]['detail_of_participants']}</h3>
                                            <div className='bottom-border-blue-auswerten mt-2'></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-responsive table-participants">
                                            <table className={this.state.participated_user_list && this.state.participated_user_list.userparticipated.length > 4 ? "member-table custom-scroll" : "member-table"}>
                                                <thead>
                                                    <tr>
                                                        <td>{SURVEY_ANALYSIS[LANGUAGE_CODE]['table_column_member_name']}</td>
                                                        <td>{SURVEY_ANALYSIS[LANGUAGE_CODE]['table_column_date']}</td>
                                                        <td>{SURVEY_ANALYSIS[LANGUAGE_CODE]['table_column_time']}</td>
                                                        <td>{SURVEY_ANALYSIS[LANGUAGE_CODE]['table_column_duration']}</td>
                                                        <td>{SURVEY_ANALYSIS[LANGUAGE_CODE]['table_column_action']}</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ParticipantsList participated_user_list={this.state.participated_user_list} deleteParticipant={this.confirmDeleteParticipant} />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row graph">
                                <div className="col-12">
                                    {this.props.isDrawChart && this.state.questionList && <GoogleChart chartData={this.state.questionList} chart_loaded_once={this.state.chart_loaded_once} smallScreenQuestionList={this.state.smallScreenQuestionList} chartColor={this.state.surveyData.survey_color}/>}
                                    {this.props.isDrawChart && this.state.demographicList && <GoogleChartDemographic chartData={this.state.demographicList} chart_loaded_once={this.state.chart_loaded_once} questionLength={this.state.questionList.length} smallScreenDemographicList={this.state.smallScreenDemographicList}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Analyze;